import React, { useState } from "react";
import EmployeeList from "./EmployeeList";
import { Employee } from "src/redux/types/_employee.type";
import EditEmployee from "./EditEmployee";

type View = "list" | "edit";

const EmployeesView = () => {
  const [view, setView] = useState<View>("list");
  const [editEmployee, setEditEmployee] = useState<Employee>();

  const defaultView = () => {
    setView("list");
  };

  const editDetails = (employee: Employee) => {
    setEditEmployee(employee);
    setView("edit");
  };

  const renderView = () => {
    switch (view) {
      case "list":
        return <EmployeeList edit={editDetails}/>;
      case "edit":
        return (
          <EditEmployee defaultView={defaultView} employee={editEmployee!} />
        );
    }
  };

  return (
      <div>{renderView()}</div>
  );
};

export default EmployeesView;
